import "../../../scss/components/_forms.scss";

import {
  Table,
  TableHead,
  TableBody,
  TableCell,
  TablePagination,
  TableRow,
} from "@mui/material";

import React, {
  useState,
  KeyboardEvent,
} from "react";
import { Button } from "@finpay-development/shared-components";
import OpenSearchInput from "./open-search-input";
import OpenSearchModal from "./open-search-modal";
import OpenSearchPatientRow from "./open-search-patient-row";

import { patientSearchResult } from "src/admissions-advisor/models/patient";
import {
  usePatientSearch
} from '../../../shared/patient-search/usePatientSearch';


export interface APIConfig {
  paramId: number;
  page: number;
  limit: number;
  searchTerms: string;
  isClicked: boolean;
  addTimingRiskFilter?: boolean
}

const tableCellStyle = { borderBottom: "none", padding: "5px 5px" };
const cellIconWidth = "5%";
const cellNameWidth = "25%";
const cellDOBWidth = "15%";
const cellEmailWidth = "55%";

const OpenSearchPatient = () => {

  const [patientIdToOpen, setPatientIdToOpen] = useState("");

  const {
    inputValue,
    setInputValue,
    patientsList,
    patientsCount,
    isLoading,
    page,
    rowsPerPage,
    handlePageChange,
    handleChangeRowsPerPage,
    searchNow,
    reset,
  } = usePatientSearch({
    paramId: -2,
    debounceMs: 500,
    minLength: 3,
    addTimingRiskFilter: false,
  });


  const handleExpandPatientTable = (documentId: string) => {
    if (patientIdToOpen === documentId) {
      setPatientIdToOpen("");
    } else {
      setPatientIdToOpen(documentId);
    }
  };

  const resetState = () => {
    setPatientIdToOpen("");
    reset();
  };

  const handleKeyUp = async (event: KeyboardEvent) => {
    if (event.key === "Enter") {
      await searchNow(true);
    }
  };

  const ActionButton = (
    <Button
      onClick={async () => {
        await searchNow(true);
      }}
    >
      Submit
    </Button>
  );

  return (
    <OpenSearchModal
        resetState={resetState}
        actionButton={ActionButton}
    >
      <OpenSearchInput
        inputValue={inputValue}
        isLoading={isLoading}
        handleInputChange={(e)=> setInputValue(e.target.value)}
        handleKeyUp={handleKeyUp}
      />
      {patientsList.length > 0 && (
        <>
          <Table size="medium" sx={{ marginTop: "10px" }}>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={tableCellStyle}
                  width={cellIconWidth}
                ></TableCell>
                <TableCell sx={tableCellStyle} width={cellNameWidth}>
                  Name
                </TableCell>
                <TableCell sx={tableCellStyle} width={cellDOBWidth}>
                  DOB
                </TableCell>
                <TableCell sx={tableCellStyle} width={cellEmailWidth}>
                  Email
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {patientsList.map((patient: patientSearchResult) => {
                return (
                  <OpenSearchPatientRow
                    patient={patient}
                    patientIdToOpen={patientIdToOpen}
                    key={patient._id}
                    handleExpandPatientTable={handleExpandPatientTable}
                  />
                );
              })}
            </TableBody>
          </Table>
          {patientsCount > 0 && (
            <TablePagination
              component="div"
              onPageChange={handlePageChange}
              page={page}
              count={patientsCount}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </>
      )}
      {patientsList.length === 0 &&
        !isLoading &&
        inputValue.length > 2 && (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <b>No Matching Results To Show</b>
          </div>
        )}
    </OpenSearchModal>
  );
};

export default OpenSearchPatient;
